"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isHtml;
function isHtml(str) {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}